import Cookies from "js-cookie";

// Session lifetime (matches MediaBack's sliding session):
// - idle: signed out after SESSION_IDLE_MS without any input (clicks, keys, scrolling, touch), across all tabs;
// - absolute: every session cookie expires at sign-in + SESSION_MAX_MS, so cookies never expire out of step.
export const SESSION_IDLE_MS = 60 * 60 * 1000;
export const SESSION_MAX_MS = 12 * 60 * 60 * 1000;
export const SESSION_PING_MS = 5 * 60 * 1000;
export const LAST_ACTIVITY_KEY = "mediasfu:lastActivity";
export const IDLE_SIGNOUT_FLAG = "mediasfu:signedOutIdle";

const STARTED_COOKIE = "sessionStartedAt";

export function markSessionStarted(now = Date.now()) {
  Cookies.set(STARTED_COOKIE, String(now), { expires: new Date(now + SESSION_MAX_MS) });
  recordActivity(now);
}

export function sessionStartedAt(now = Date.now()) {
  const started = Number(Cookies.get(STARTED_COOKIE));
  return Number.isFinite(started) && started > 0 && started <= now ? started : now;
}

// The one expiry every session cookie uses.
export function sessionCookieExpiry(now = Date.now()) {
  return new Date(Math.min(sessionStartedAt(now) + SESSION_MAX_MS, now + SESSION_MAX_MS));
}

export function clearSessionStarted() {
  Cookies.remove(STARTED_COOKIE);
}

export function recordActivity(now = Date.now()) {
  try { window.localStorage.setItem(LAST_ACTIVITY_KEY, String(now)); } catch {}
}

export function lastActivityAt(now = Date.now()) {
  try {
    const value = Number(window.localStorage.getItem(LAST_ACTIVITY_KEY));
    return Number.isFinite(value) && value > 0 ? Math.min(value, now) : now;
  } catch {
    return now;
  }
}

export function flagIdleSignOut() {
  try { window.sessionStorage.setItem(IDLE_SIGNOUT_FLAG, "1"); } catch {}
}

export function consumeIdleSignOutFlag() {
  try {
    const flagged = window.sessionStorage.getItem(IDLE_SIGNOUT_FLAG) === "1";
    if (flagged) window.sessionStorage.removeItem(IDLE_SIGNOUT_FLAG);
    return flagged;
  } catch {
    return false;
  }
}
